import { Box, Stack, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import Section from './Section';
import { DividerStyled, PageRoot, SectionCard, SectionCardContent, SectionTitleWrapper, TablesWrapper } from './styled';
import type { SummaryDetailsProps } from './types';

const SummaryDetails = ({ controller: vm }: SummaryDetailsProps) => {
  return (
    <>
      <PageRoot>
        {/* Main content: two equal columns on md+ so cards use available width */}
        <Box
          sx={{
            mt: 1,
            width: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: 2,
            alignItems: 'stretch',
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Stack spacing={2}>
              {vm?.leftColumn?.map((sec) => (
                <Section key={sec.title} pinScope={sec.title} {...sec} />
              ))}
            </Stack>
          </Box>

          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Stack spacing={2}>
              {vm?.rightColumn?.map((sec) => (
                <Section key={sec.title} pinScope={sec.title} {...sec} />
              ))}
            </Stack>
          </Box>
        </Box>
      </PageRoot>

      {/* Tables */}
      {vm?.tablesSection?.fields?.length > 0 ? (
        <TablesWrapper sx={vm.tablesSection?.sx}>
          {vm.tablesSection.fields.map(({ component, icon, label, sx }) => (
            <SectionCard key={label} variant="outlined" sx={sx?.card}>
              <SectionCardContent sx={sx?.cardContent}>
                <SectionTitleWrapper sx={sx?.titleWrapper}>
                  <FontAwesomeIcon size="lg" icon={icon as IconProp} />
                  <Typography variant="h6" sx={sx?.title}>
                    {label}
                  </Typography>
                </SectionTitleWrapper>
                <DividerStyled />
                {component}
              </SectionCardContent>
            </SectionCard>
          ))}
        </TablesWrapper>
      ) : null}
    </>
  );
};

export default SummaryDetails;
